import { useContext } from 'react';
import {
  CustomerSummaryContext,
  CustomerSummaryState,
} from '../context/CustomerSummaryContext';

// Custom hook to use the CustomerSummary context
const useCustomerSummary = (): CustomerSummaryState => {
  const context = useContext(CustomerSummaryContext);
  if (context === undefined) {
    throw new Error(
      'useCustomerSummary must be used within a CustomerSummaryProvider'
    );
  }
  return context;
};

export default useCustomerSummary;
